import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  FormGroup,
  FormArray,
  Validators
} from '@angular/forms';

@Component({
  selector: 'app-drag-and-drop-file-upload',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
  ],
  templateUrl: './drag-and-drop-file-upload.component.html',
  styleUrl: './drag-and-drop-file-upload.component.css'
})
export class DragAndDropFileUploadComponent {

  @Output() filesSelectedEvent = new EventEmitter<File[]>();

  form: FormGroup = new FormGroup({
    fileControl: new FormArray([], Validators.required),
  });

  // Handle file input change
  onFileUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);
      this.filesSelectedEvent.emit(files);
    }
  }
}
